const iconSizes = {
  s: 6,
  m: 8,
  l: 12,
  xl: 14,
} as Record<"s" | "m" | "l" | "xl", number>;

export type IconSizes = keyof typeof iconSizes;

export default iconSizes;
